import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4" }
const _hoisted_2 = { class: "tw-mt-1" }
const _hoisted_3 = { class: "md:tw-col-span-2" }
const _hoisted_4 = { class: "md:tw-col-span-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }
const _hoisted_8 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-slate-700" }
const _hoisted_9 = { class: "tw-mt-6 tw-flex tw-items-center tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_BaseDateTimePicker = _resolveComponent("BaseDateTimePicker")!
  const _component_ContainerReturnLocationDropdown = _resolveComponent("ContainerReturnLocationDropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: "edit-container-details-modal",
    subtitle: "Update container fields, then save.",
    maxWidth: "5xl",
    onClose: _ctx.onCancel
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Edit Container #" + _toDisplayString(String(_ctx.modelForEdit.internalIndex).padStart(2, '0')) + "-" + _toDisplayString(_ctx.modelForEdit.containerId) + " ", 1),
      _createVNode(_component_CopyButton, {
        value: String(_ctx.modelForEdit.containerId),
        title: "Copy container number",
        ariaLabel: "Copy container number"
      }, null, 8, ["value"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Size Type", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FilterableDropdown, {
              modelValue: _ctx.modelForEdit.sizeType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelForEdit.sizeType) = $event)),
              options: _ctx.allSizeTypeOptions,
              class: "tw-w-full",
              clearable: false,
              components: { OpenIndicator: null, Deselect: null }
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Seal Number", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelForEdit.sealNumber) = $event))
          }, null, 512), [
            [_vModelText, _ctx.modelForEdit.sealNumber]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Cargo Pieces", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelForEdit.cargoPieces) = $event))
          }, null, 512), [
            [_vModelText, _ctx.modelForEdit.cargoPieces]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Weight", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelForEdit.weight) = $event))
          }, null, 512), [
            [_vModelText, _ctx.modelForEdit.weight]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Cargo Description", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelForEdit.cargoDescription) = $event))
          }, null, 512), [
            [_vModelText, _ctx.modelForEdit.cargoDescription]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Reference #", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelForEdit.referenceNumber) = $event))
          }, null, 512), [
            [_vModelText, _ctx.modelForEdit.referenceNumber]
          ])
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "tw-block tw-text-xs tw-font-semibold tw-text-slate-500 tw-uppercase" }, "EIR In", -1)),
              _createVNode(_component_BaseDateTimePicker, {
                type: "datetime",
                "value-type": "format",
                format: "YYYY-MM-DD HH:mm",
                modelValue: _ctx.modelForEdit.eirIn,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelForEdit.eirIn) = $event)),
                class: "tw-mt-1"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "tw-block tw-text-xs tw-font-semibold tw-text-slate-500 tw-uppercase" }, "EIR Out", -1)),
              _createVNode(_component_BaseDateTimePicker, {
                type: "datetime",
                "value-type": "format",
                format: "YYYY-MM-DD HH:mm",
                modelValue: _ctx.modelForEdit.eirOut,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelForEdit.eirOut) = $event)),
                class: "tw-mt-1"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Terminal Appt", -1)),
          _createVNode(_component_BaseDateTimePicker, {
            "value-type": "YYYY-MM-DD HH:mm",
            "date-format": "MM/DD/YYYY",
            "date-time-format": "MM/DD/YYYY HH:mm",
            "allow-time-toggling": true,
            "show-days-shortcuts": true,
            "controls-placement": "popup",
            "minute-step": 15,
            "time-panel-placement": "beside-calendar",
            modelValue: _ctx.modelForEdit.terminalAppointmentDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelForEdit.terminalAppointmentDate) = $event)),
            "has-time": _ctx.modelForEdit.terminalAppointmentHasTime,
            "onUpdate:hasTime": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelForEdit.terminalAppointmentHasTime) = $event)),
            class: "tw-mt-1"
          }, null, 8, ["modelValue", "has-time"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.isExportOrder ? 'Pick-Up Appt' : 'Delivery Appt'), 1),
          _createVNode(_component_BaseDateTimePicker, {
            "value-type": "YYYY-MM-DD HH:mm",
            "date-format": "MM/DD/YYYY",
            "date-time-format": "MM/DD/YYYY HH:mm",
            "allow-time-toggling": true,
            "show-days-shortcuts": true,
            "controls-placement": "popup",
            "minute-step": 15,
            "time-panel-placement": "beside-calendar",
            modelValue: _ctx.modelForEdit.deliveryAppointmentDate,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelForEdit.deliveryAppointmentDate) = $event)),
            "has-time": _ctx.modelForEdit.deliveryAppointmentHasTime,
            "onUpdate:hasTime": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelForEdit.deliveryAppointmentHasTime) = $event)),
            class: "tw-mt-1"
          }, null, 8, ["modelValue", "has-time"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelForEdit.isReturningToAnotherLocation) = $event)),
              type: "checkbox",
              class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
            }, null, 512), [
              [_vModelCheckbox, _ctx.modelForEdit.isReturningToAnotherLocation]
            ]),
            _cache[26] || (_cache[26] = _createTextVNode(" Return to Another Location? ", -1))
          ]),
          (_ctx.modelForEdit.isReturningToAnotherLocation)
            ? (_openBlock(), _createBlock(_component_ContainerReturnLocationDropdown, {
                key: 0,
                modelValue: _ctx.modelForEdit.returnLocation,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelForEdit.returnLocation) = $event)),
                placeholder: "select customer or terminal...",
                class: "tw-mt-1 tw-w-full"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[27] || (_cache[27] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Return Terminal Appt", -1)),
          _createVNode(_component_BaseDateTimePicker, {
            "value-type": "YYYY-MM-DD HH:mm",
            "date-format": "MM/DD/YYYY",
            "date-time-format": "MM/DD/YYYY HH:mm",
            "allow-time-toggling": true,
            "show-days-shortcuts": true,
            "controls-placement": "popup",
            "minute-step": 15,
            "time-panel-placement": "beside-calendar",
            modelValue: _ctx.modelForEdit.returnTerminalAppointmentDate,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modelForEdit.returnTerminalAppointmentDate) = $event)),
            "has-time": _ctx.modelForEdit.returnTerminalAppointmentHasTime,
            "onUpdate:hasTime": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modelForEdit.returnTerminalAppointmentHasTime) = $event)),
            class: "tw-mt-1"
          }, null, 8, ["modelValue", "has-time"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          isGreen: true,
          enableLoading: _ctx.isSaving,
          disabled: _ctx.isSaving,
          isPrimary: true,
          onClick: _ctx.onSave,
          class: "tw-p-0",
          icon: "check",
          title: "Save container details",
          "aria-label": "Save container details"
        }, {
          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["enableLoading", "disabled", "onClick"]),
        _createVNode(_component_Button, {
          isRed: true,
          onClick: _ctx.onCancel,
          isSecondary: true,
          class: "tw-p-0",
          title: "Cancel edit container details",
          "aria-label": "Cancel edit container details"
        }, {
          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
}